import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
const useStyles = makeStyles({
  firstGrid: {
    marginBottom: '16px',
    padding: '8px',
  },
});
function Form(props) {
  const classes = useStyles();
  return (
    <>
      <Grid xs={12} sm={12} md={4} className={classes.firstGrid} key={props}>
        <div
          className="form"
          style={{ height: '100%' }}
          onClick={() => {
            props.setModalData(props.data);
            props.handleFormModal(true);
          }}
        >
          <h6 style={{ textAlign: 'center', marginBottom: '4px' }}>
            {props.data.name}
          </h6>
          <p style={{ textAlign: 'center', marginBottom: '8px' }}>
            Form No: {props.data.formId}
          </p>
          <p className=" formDates" style={{ textAlign: 'center' }}>
            <span>Deadline : {props.data.deadline}</span>
            <span>Uploaded : {props.data.uploaded}</span>
          </p>
        </div>
      </Grid>
    </>
  );
}

export default Form;
